import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import CatalogListing from "@/pages/catalog/components/CatalogListing";
import InlineSearch from "@/pages/catalog/components/InlineSearch";
import usePageMeta from "@/hooks/usePageMeta";

export default function SeriesPage() {
  usePageMeta(
    "伦理电视剧 - 伦理视频",
    "伦理视频伦理电视剧频道，支持按地区、年代、评分与集数区间筛选伦理题材剧集，提供剧情介绍、角色关系分析与深度剧评。",
    "伦理电视剧,伦理剧集,家庭剧推荐,剧集剧情介绍,剧集解析,伦理视频",
  );

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Long-form Ethics"
        title="伦理电视剧"
        description="用十几集的时间，看一段关系如何缓慢地走向它的结局。剧集频道额外支持按集数区间筛选，适合想找短剧一口气看完，或想追长篇群像的观众。"
        breadcrumbs={[{ label: "首页", to: "/" }, { label: "伦理电视剧" }]}
      >
        <InlineSearch tone="dark" />
      </PageHero>
      <CatalogListing kind="series" />
    </SiteLayout>
  );
}